<template>
  <div class="main">
    <div style="width: 96%;padding-bottom: 10rem;">
      <van-contact-card type="add" add-text="添加家庭成员" style="margin-top: 2rem;"
                        @click="patientsShow = true"/>
      <van-divider>家庭成员列表</van-divider>
      <van-cell-group v-if="relatives.length > 0">
        <van-cell center :label="item.cardid|cardidFilter" v-for="item in relatives"
                  v-bind:key="item.id"
                  is-link
                  @click="del(item.id)"
        >
          <template #title>
            <strong>{{item.name}}</strong> <span style="color:#999">{{item.sexid|sexFilter}} {{item.phone}}</span>
          </template>
          <template #right-icon>
            <van-icon name="delete-o"/>移除
          </template>
        </van-cell>
      </van-cell-group>
      <div v-else>
        <van-empty description="您还没有添加家庭成员！"/>
      </div>
    </div>
    <van-popup v-model="patientsShow"
               closeable
               round
               position="bottom"
               :style="{ height: '90%' }" >
      <form action="/">
        <van-search
            v-model="phone"
            show-action
            placeholder="请输入手机号"
            @search="codeShow = true"
            @cancel="onCancel"
            style="margin-right: 10em;"
        />
      </form>
      <van-cell-group v-if="persons.length > 0">
        <van-cell center :label="item.cardid|cardidFilter" v-for="item in persons"
                  v-bind:key="item.id" @click="add(item)">
          <template #title>
            <strong>{{item.name}}</strong> {{item.sexid|sexFilter}}
          </template>
          <template #right-icon>
            <span v-if="isAdded(item.patientid)" style="color: #ccc">已添加</span>
            <span v-if="!isAdded(item.patientid)"><van-icon name="plus"/>添加</span>
          </template>
        </van-cell>
      </van-cell-group>
    </van-popup>
    <van-popup v-model="codeShow"
               closeable
               round
               :style="{ width: '100%' }" >
      <div style="margin-right: 6em;">
        <van-field
            v-model="code"
            center
            type="digit"
            name="短信验证码"
            label="短信验证码"
            placeholder="短信验证码"
            @input="formatterCode"
        >
          <template #button>
            <van-button size="small" @click="getIdentifyCode" :disabled="sendDisabled"
                        color="linear-gradient(to right, #10E3E9, #409EFF)"
                        style="color: #fff;width: 90px;height: 35px;">{{ sendText }}
            </van-button>
          </template>
        </van-field>
        <div style="margin:5rem 5px 2rem;">

          <van-button @click="getPatients"
                      block
                      round
                      color="linear-gradient(to right, #10E3E9, #409EFF)"
                      style="color: #fff;font-size: 18px;">查 询
          </van-button>
        </div>
      </div>

    </van-popup>
  </div>
</template>

<script>
import {HideCardIdStr} from '@/assets/utils/utils'
import {
  getRelatives,
  addRelatives,
  deleteRelatives,
  getCode,
  getPatientsByPhoneAndCode
} from '@/api/module/user'
import {Dialog, Toast} from "vant";
import {decrypt, encrypt} from '../../assets/utils/cryptoUtil.js'

export default {
  name: "index",
  data() {
    return {
      relatives: [],
      patientsShow:false,
      codeShow:false,
      phone:'',
      persons: [],
      code: '',
      sendDisabled: false,
      sendText: '发送验证码',
    };
  },
  filters:{
    valFilter:function (value){
      let val = decrypt(value)
      return val
    },
    sexFilter:function (val){
      switch (val){
        case '1':
        {
          return '男'
        }
        case '2':
        {
          return '女'
        }
        default:
        {
          return '未说明'
        }
      }
    },
    cardidFilter:function (val){
      return '身份证：' + HideCardIdStr(val)
    }
  },
  created() {
    this.getRelativeList()
  },
  methods: {
    //手机号码验证
    phonevalidate() {
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!myreg.test(this.phone)) {
        Toast.fail('请填写正确的手机号码');
        return false;
      } else {
        return true;
      }
    },
    //获取短信验证码
    getIdentifyCode() {
      let param = {
        phone: encrypt(this.phone),
        name: this.hospitalname
      }
      if (this.phone == '') {
        Toast.fail('请填写手机号码！');
        return
      }
      if (!this.phonevalidate()) {
        return
      }
      getCode(param).then(res => {
        if (res.code == 200) {
          Toast.success(res.msg, {duration: 2000});
          if (res.data == 1) {
            this.sendDisabled = true
            //发送之后，60秒后才能重新发送
            const start = (e) => {
              let timer = null
              timer = setInterval(() => {
                this.sendText = '重发(' + e + ')'
                e--
                if (e < 0) {
                  clearInterval(timer)
                  this.sendDisabled = false
                  this.sendText = '发送验证码'
                }
              }, 1000)
            }
            start(60)
          }
        }
      })
    },
    //修复ios 短信验证码自动填充时总是被复制两遍
    formatterCode(val) {
      if (val.length > 6) {
        this.code = val.substr(0, 6)
      }
    },
    isAdded(patientid) {
      return this.relatives.some(relative => relative.patientid === patientid);
    },
    add(item) {
      if (this.relatives.length > 10) {
        Dialog.alert({
          title: '提示',
          message: '超出上限，不能继续添加！',
        }).then(() => {
        });
        return
      }
      // 已添加
      if(this.isAdded(item.patientid)){
        return;
      }
      let newParam = {}
      newParam.relativeId = this.$encruption(JSON.parse(localStorage.getItem("loginuser")).patientid)
      newParam.patientid = this.$encruption(item.patientid)
      newParam.name = encrypt(item.name)
      newParam.sexid = item.sexid
      newParam.phone = encrypt(item.phone)
      newParam.cardid = encrypt(item.cardid)
      newParam.birthdate = item.birthdate
      addRelatives(newParam).then(res => {
        if (res.code == 200) {
          if (res.data == -1) {
            Toast.fail(res.msg);
          } else {
            Toast.success('添加成功！')
            this.patientsShow = false
            this.getRelativeList()
          }
        }
      })
    },
    toUserInfo() {
      this.$router.push({name: 'userinfo'})
    },
    //查询家属成员
    getRelativeList() {
      let param = {
        patientid: this.$encruption(JSON.parse(localStorage.getItem("loginuser")).patientid),
      }
      getRelatives(param).then(res => {
        //2025-07-03 luotong 处理PatientID加密出错导致的出错
        if(res.data == -1 && res.msg === "参数patientid错误"){
          Dialog({
            message: "登录过期，返回重新登录",
            theme: 'round-button',
          }).then(() => {
            window.localStorage.removeItem("loginuser")
            localStorage.removeItem("token")
            this.$router.push({name: 'login'})
          });
        }
        if (res.code == 200) {
          if(res.data == -1){
            Dialog({
              message: res.msg + ',请立即联系体检中心处理，电话：' + this.phone,
              theme: 'round-button',
            });
          }
          else{
            this.relatives = res.data
            this.relatives.forEach(item=>{
              item.name = decrypt(item.name)
              item.cardid = decrypt(item.cardid)
              item.phone = decrypt(item.phone)
            })
          }
        }
      })
    },
    //根据关键字查询已注册用户列表
    getPatients() {
      if(this.code.trim() === ""){
        Toast.fail("请输入验证码");
        return;
      }
      let param = {
        phone: encrypt(this.phone),
        patientid: this.$encruption(JSON.parse(localStorage.getItem("loginuser")).patientid),
        code:this.code,
      }
      getPatientsByPhoneAndCode(param).then(res => {
        if(res.data != null){
          this.persons = res.data
          this.persons.forEach(item=>{
            item.name = decrypt(item.name)
            item.cardid = decrypt(item.cardid)
            item.phone = decrypt(item.phone)
          })
          this.codeShow = false
        }
        else{
          Toast.fail(res.msg);
        }
      })
    },
    onCancel(){

    },
    del(id) {
      Dialog.confirm({
        title: '提示',
        message: '确认要移除吗',
      }).then(() => {
        //移除亲属
        let param = {
          id: id
        }
        deleteRelatives(param).then(res => {
          if (res.code == 200) {
            if (res.data == 1) {
              Toast.success('移除成功！');
              this.patientsShow = false
              this.getRelativeList()
            } else {
              Toast.fail('移除失败!');
            }
          }
        })
      }).catch(() => {
      });
    },
  },
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
  display: flex;
  justify-content: center;
}
</style>
